<div class="app-action-tablet-header">
  <sc-padding>
    <sc-flex stretchContent>
      @for (station of actionTabletContext?.selectedStations; track station; let i = $index) {
        @if (i>0) {
          <sc-content-spacer></sc-content-spacer>
        }
        <app-action-tablet-header-station-tab [stationId]="station" [selected]="isStationSelected(station)"
          (close)="closeStation($event)"
        (select)="selectStation($event)"></app-action-tablet-header-station-tab>
      }
      <sc-content-spacer grow></sc-content-spacer>
      <button mat-icon-button class="options-icon-button" (click)="chooseStation()">
        <sc-icon iconClass="fa-plus"></sc-icon>
      </button>
    </sc-flex>
  </sc-padding>
</div>
